import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import { PageHero, SectionHead, FeatureCard, CtaBand, Reveal } from "../components/ui.js";

/* LEVELUP ONE — วิสัยทัศน์ (Vision) */
export default class Vision extends Component {
  componentDidMount() { loading(false); window.scrollTo(0, 0); }
  render() {
    const missions = [
      { icon: "🌱", title: "ทำให้ AI เข้าถึงได้", desc: "ธุรกิจทุกขนาดควรมีทีม AI ในราคาที่จับต้องได้" },
      { icon: "🔗", title: "ไม่ทิ้งระบบเดิม", desc: "ต่อยอดจากเครื่องมือที่ลูกค้าใช้อยู่ ไม่บังคับให้เริ่มใหม่" },
      { icon: "📐", title: "เน้นผลลัพธ์ที่วัดได้", desc: "ทุกโซลูชันต้องสร้างผลลัพธ์จริงให้ธุรกิจ" },
      { icon: "♻️", title: "เติบโตอย่างยั่งยืน", desc: "สร้างเทคโนโลยีที่ดูแลต่อได้ในระยะยาว" },
    ];
    return (
      <div className="nx">
        <Navbar />
        <PageHero crumb="วิสัยทัศน์" eyebrow="วิสัยทัศน์" title="ทำให้ทุกธุรกิจไทยมีพลังของ AI"
          subtitle="ทิศทางและพันธกิจที่ขับเคลื่อนการทำงานของเราในทุก ๆ วัน" />
        <section className="nx-section nx-bg-soft">
          <div className="container">
            <Reveal>
              <div className="text-center" style={{ maxWidth: 760, margin: "0 auto" }}>
                <span className="nx-eyebrow">วิสัยทัศน์</span>
                <h2 className="nx-heading mt-3">ทำให้ AI เป็นเรื่องที่ <span className="nx-gradient-text">ทุกธุรกิจเข้าถึงได้</span></h2>
                <p className="nx-subtitle" style={{ margin: "0 auto" }}>เราอยากเห็นธุรกิจไทยทุกขนาดมีทีมงาน AI ที่ช่วยทำงานได้ตลอด 24 ชั่วโมง ปลดล็อกเวลาให้เจ้าของธุรกิจไปโฟกัสกับสิ่งที่สำคัญ</p>
              </div>
            </Reveal>
          </div>
        </section>
        <section className="nx-section">
          <div className="container">
            <Reveal><SectionHead center eyebrow="พันธกิจ" title="สิ่งที่เราตั้งใจทำให้สำเร็จ" /></Reveal>
            <div className="row g-4 mt-2">
              {missions.map((m, i) => (
                <div className="col-12 col-sm-6 col-lg-3" key={m.title}>
                  <Reveal delay={i * 60}><FeatureCard {...m} /></Reveal>
                </div>
              ))}
            </div>
          </div>
        </section>
        <CtaBand />
        <Footer />
      </div>
    );
  }
}
